/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService
 */

export const getPortalAggregationsRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.MyTeamChirpService',
  rpcName: 'getPortalAggregations',
  auth: 'app',
  fingerprint: 'ycl3Sarss-xlQzuybklimL_sCbAAL1t-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCertificationAggregationsByStatusRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.MyTeamChirpService',
  rpcName: 'getCertificationAggregationsByStatus',
  auth: 'app',
  fingerprint: 'JOUXMlg8x0h_Qho8BdftyL_sCbAAL1t-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTeamMemberCertificationAggregationsByStatusRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.MyTeamChirpService',
  rpcName: 'getTeamMemberCertificationAggregationsByStatus',
  auth: 'app',
  fingerprint: 'OqHBiMADQ7mfpi8WCHdQ8b_sCbAAL1t-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTeamMembersCertificationsByStatusRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.MyTeamChirpService',
  rpcName: 'getTeamMembersCertificationsByStatus',
  auth: 'app',
  fingerprint: 'eKn3Ihg8b7jSa3xE2gUGmL_sCbAAL1t-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getIndividualCertificationOverviewRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.MyTeamChirpService',
  rpcName: 'getIndividualCertificationOverview',
  auth: 'app',
  fingerprint: 'Vm8fUDJuzGs7y4fR0KZdYL_sCbAAL1t-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCertificateRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.MyTeamChirpService',
  rpcName: 'getCertificate',
  auth: 'app',
  fingerprint: 'nKxfrrQZw-oUuFGA68hzE7_sCbAAL1t-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};